import { render, staticRenderFns } from "./ViewsList.vue?vue&type=template&id=192c11d7&"
import script from "./ViewsList.vue?vue&type=script&lang=js&"
export * from "./ViewsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports